import { render, staticRenderFns } from "./PrlekijaContent.vue?vue&type=template&id=4457b33c&scoped=true&"
import script from "./PrlekijaContent.vue?vue&type=script&lang=js&"
export * from "./PrlekijaContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4457b33c",
  null
  
)

export default component.exports